import MaterialTable from "@material-table/core";
import { Row } from "../../components/Layout";
import { log } from "../../Helper";
import { useRef } from "react";

export const SelectedMachinesTable = (props) => {
  const tableRef = useRef(null);

  const { selectedMachines, weight, onSequenceUpdate } = props;

  const modalColumn = [
    {
      title: "Location",
      field: "from",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "Ship To",
      field: "to",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "DIM (meter)",
      field: "diameter",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "Weight (Kg)",
      field: "weight",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "Serial No",
      field: "serial",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "Model",
      field: "product",
      editable: "never",
      headerStyle: {
        fontSize: "11px",
      },
    },
    {
      title: "OrderPath ID",
      field: "orderPathId",
      editable: "never",
      hidden: true,
    },
    {
      title: "Build ID",
      field: "buildId",
      editable: "never",
      hidden: true,
    },
    {
      title: "Sequence",
      field: "sequence",
      render: (rowData) => {
        return (
          <input type="number" min="0" 
            defaultValue={rowData.sequence == undefined ? 0 : rowData.sequence}
            onBlur={(e) => handleBlur(rowData, e)}
          />
        );
      },
      editable: "always",
      headerStyle: {
        fontSize: "11px",
      },
    },
  ];

  const handleBlur = (rowdata, e) => {
    const newSequence = e.target.value !== "" ? e.target.value : "0";
    if (onSequenceUpdate) {
      onSequenceUpdate(rowdata.orderPathId, newSequence);
    } else {
      // Fallback to direct assignment if callback not provided
      rowdata.sequence = 0;
    }
  };

  return (
    <div className="mt-n2">
      <MaterialTable
        ref={tableRef}
        options={{
          rowStyle: {
            fontSize: 9,
          },
          selection: false,
          search: false,
          showTitle: false,
          sorting: false,
          paging: false,
          draggable: false,
          headerStyle: {
            backgroundColor: "#367c2b",
            fontWeight: "200",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          tableContainerStyle: {
            overflow: "auto",
          },
          filterCellStyle: {
            flex: 1
          },
        }}
        columns={modalColumn}
        data={selectedMachines}
      />
      <br />

      <Row xs={8}>
        <label className="text-xs ">Total Weight(Kg) : {weight}</label>
      </Row>
    </div>
  );
};
